import { graphql } from '../../../../graphql/generated';

export const CREATE_TEST_TUBE_MUTATION = graphql(`
  mutation CreateTestTube($input: TestTubeCreateInput!) {
    createTestTube(input: $input) {
      id
    }
  }
`);
